import type { PracticeMember } from './members.types';

/**
 * Narrows the roster by a free-text query, matched case-insensitively against the member's
 * "first last" name or their MDVIP ID. An empty or whitespace-only query matches everything, so
 * a cleared search box falls back to the full roster rather than to nothing.
 */
export function filterMembers(members: PracticeMember[], query: string): PracticeMember[] {
  const term = query.trim().toLowerCase();
  if (!term) return members;

  return members.filter((member) => {
    // Joined, not matched per part, so "sarah ch" finds Sarah Chen. A null part drops out rather
    // than becoming "null", and the filter keeps the single space between remaining parts.
    const name = [member.firstName, member.lastName].filter(Boolean).join(' ').toLowerCase();
    if (name.includes(term)) return true;
    return Boolean(member.mdvipId?.toLowerCase().includes(term));
  });
}
